import { Box, Icon, Text } from '@quintoandar-tokko/jopijs';
import styles from './styles.module.scss';

const QUALIFICATION = {
  UNRATED: 'without_calification',
  POSITIVE: 'positive',
  NEGATIVE: 'negative',
  NEUTRAL: 'neutral',
};

const QUALIFICATION_ICON = {
  [QUALIFICATION.UNRATED]: 'icon-mostrarmenos',
  [QUALIFICATION.POSITIVE]: 'icon-positivo',
  [QUALIFICATION.NEGATIVE]: 'icon-negativo',
  [QUALIFICATION.NEUTRAL]: 'icon-neutro',
};

export default function AssignmentCell({
  assignmentDate,
  closeDate,
  qualification,
  ...rest
}) {
  const safetyQualification = qualification ?? QUALIFICATION.UNRATED;

  return (
    <Box className={styles.assignmentCell} {...rest}>
      <Text className={styles.assignmentCellTitle}>{assignmentDate}</Text>
      <Box
        className={styles.assignmentCellBottomWrapper}
        data-qualification={safetyQualification}
      >
        <Icon
          className={styles.assignmentCellIcon}
          icon={QUALIFICATION_ICON[safetyQualification]}
        />

        {closeDate && (
          <Text className={styles.assignmentCellSubtitle}>{closeDate}</Text>
        )}
      </Box>
    </Box>
  );
}
